import React, { useState, useEffect } from 'react';
import utils from '../../utils';
import Pagination from './Pagination';
import JournalResult from './JournalResult';
import ResultsSummary from './ResultsSummary';
import NoResults from './NoResults';
import __ from '../internetLanguage';
import solrInstances from '../solrInstances';
import searchStates from '../../searchStates';

export default function JournalResults(props) {
	const [page, setPage] = useState(1);
	const [isNewSearch, setIsNewSearch] = useState(true);
	const [searchState, setSearchState] = useState(searchStates.READY);
	const [totalResults, setTotalResults] = useState(0);
	const [results, setResults] = useState([]);

	const form = props.form;
	const data = form.data;
	const isActive = props.isActive;
	const onTotalResultsUpdate = props.onTotalResultsUpdate;
	const isEmpty = utils.isFormEmpty(data);

	const solr = solrInstances.en.journal;

	const doSearch = (pageNum) => {
		pageNum && setPage(pageNum);
		setSearchState(searchStates.SEARCHING);
		solr.query(data, { page: pageNum || page })
			.then((response) => {
				setTotalResults(response.total);
				setResults(response.results);
				if (response.error && !response.length) {
					setSearchState(searchStates.ERROR);
					console.error('Search: Journal search error: ', response.error);
				} else {
					setSearchState(searchStates.DONE);
				}
			})
			.catch((error) => {
				console.error('Search: Journal search fail: ', error);
				setSearchState(searchStates.ERROR);
			});
	};

	const clearResults = () => {
		setResults([]);
		setTotalResults(0);
		setPage(1);
	};

	const goToPage = (pageNum) => {
		if ('number' !== typeof pageNum || 1 > pageNum || pageNum === page) {
			return;
		}
		utils.toTop();
		doSearch(pageNum);
	};

	// On form change, update newSearch flag
	useEffect(() => {
		clearResults();
		if (!isEmpty) {
			setIsNewSearch(true);
		} else {
			setSearchState(searchStates.READY);
		}
	}, [data]);

	// On Active
	useEffect(() => {
		if (!isEmpty && isActive && isNewSearch) {
			doSearch();
			setIsNewSearch(false);
		}
	}, [isActive, isNewSearch]);

	// Notify parent component of total results changes
	useEffect(() => {
		if (onTotalResultsUpdate) {
			onTotalResultsUpdate(totalResults);
		}
	}, [totalResults]); // Only depend on totalResults, not the callback function

	return (
		<div className="results journalResults" data-cdc-total={totalResults}>
			<ResultsSummary
				isEmpty={isEmpty}
				page={page}
				searchState={searchState}
				totalResults={totalResults}
				form={form}
				isAdvanced={true}
				resultType="journals"
			/>
			{!results.length ? (
				<NoResults isEmpty={isEmpty} searchState={searchState} />
			) : (
				<div>
					{results.map((result, resultIndex) => (
						<JournalResult key={resultIndex} result={result} />
					))}

					<Pagination
						page={page}
						totalResults={totalResults}
						goToPage={goToPage}
						anchor="#results-journals"
					/>
				</div>
			)}
		</div>
	);
}
